import { useEffect, useState } from "react";
import { UserOutlined } from "@ant-design/icons";
import { Authenticate } from "../../service/Authenticate.service";
import { useNavigate } from "react-router-dom";
import {
  ShopOutlined,
  ShoppingCartOutlined,
  HistoryOutlined,
  KeyOutlined,
} from "@ant-design/icons";
import { ModalCart } from "../../components/modal/cart";
import {
  Layout,
  Menu,
  Typography,
  Spin,
  Row,
  Col,
  Modal,
  ConfigProvider,
  Alert,
  Form,
  Input,
  message,
} from "antd";
import UserService from "../../service/User.service";
const authService = Authenticate();
const userService = UserService();
const App = () => {
  const navigate = useNavigate();
  const [userInfo, setUserInfo] = useState(null);
  const [loading, setLoading] = useState(false);
  
  const [ModalCartOpen, setModalCartOpen] = useState(false);
  const [ModalLogoutOpen, setModalLogoutOpen] = useState(false);
  const [ModalPasswordOpen, setModalPasswordOpen] = useState(false);
  const [passwordSaving, setPasswordSaving] = useState(false);
  const [passwordForm] = Form.useForm();
  const [current, setCurrent] = useState("menu1");

  const onChangePassword = () => {
    passwordForm.validateFields().then((v) => {
      setPasswordSaving(true);
      userService
        .changePassword({ oldpwd: v.oldpwd, newpwd: v.newpwd })
        .then(() => {
          message.success("เปลี่ยนรหัสผ่านสำเร็จ");
          passwordForm.resetFields();
          setModalPasswordOpen(false);
        })
        .catch((err) => {
          const msg =
            err?.response?.data?.message || "เปลี่ยนรหัสผ่านไม่สำเร็จ";
          message.error(msg);
        })
        .finally(() => setPasswordSaving(false));
    });
  };
  const onLogout = () => {
    setLoading(true);
    setTimeout(() => {
      authService.removeToken();
      setLoading(false);
      navigate("/", { replace: true });
    }, 600);
  };
  useEffect(() => {
    const users = authService.getUserInfo();
    setUserInfo(users);

    return () => {};
  }, []);
  const onClick = (e) => {
    // console.log("click ", e);
    setCurrent(e.key);
  };
  return (
    <Spin spinning={loading}>
      <Layout>
        <ConfigProvider
          theme={{
            token: {
              // Seed Token
              colorPrimary: "#F7F9F9",
              colorText: "#FFFFFF",
              colorBgContainer: "#78909c",
            },
          }}
        >
          <Row style={{ height: 45, minWidth: 390 }}>
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Menu
                onClick={onClick}
                selectedKeys={[current]}
                mode="horizontal"
                style={{ paddingLeft: 20 }}
              >
                <Menu.Item>
                  <ShopOutlined style={{ paddingRight: 5 }} />
                  <Typography.Link href="/ecommerce" rel="noopener noreferrer">
                    สินค้า
                  </Typography.Link>
                </Menu.Item>
                <Menu.Item>
                  <HistoryOutlined style={{ paddingRight: 5 }} />
                  <Typography.Link href="/history" rel="noopener noreferrer">
                    ประวัติการสั่งซื้อ
                  </Typography.Link>
                </Menu.Item>
                <Menu.Item>
                  <ShoppingCartOutlined style={{ paddingRight: 5 }} />
                  <Typography.Link
                    onClick={() => setModalCartOpen(true)}
                    rel="noopener noreferrer"
                  >
                    ตะกร้าสินค้า
                  </Typography.Link>
                </Menu.Item>
                <Menu.Item>
                  <KeyOutlined style={{ paddingRight: 5 }} />
                  <Typography.Link
                    onClick={() => setModalPasswordOpen(true)}
                    rel="noopener noreferrer"
                  >
                    เปลี่ยนรหัสผ่าน
                  </Typography.Link>
                </Menu.Item>
                <Menu.Item
                  style={{
                    position: "absolute",
                    top: 0,
                    right: 0,
                    backgroundColor: "#78909c",
                    width: 160,
                  }}
                >
                  <Typography.Link
                    onClick={() => setModalLogoutOpen(true)}
                    rel="noopener noreferrer"
                  >
                    <UserOutlined />
                    <span
                      style={{
                        letterSpacing: 0.7,
                        fontWeight: 600,
                        textTransform: "uppercase",
                        paddingRight: 10,
                        
                      }}
                    >
                      {userInfo?.prename}
                      {userInfo?.firstname}
                      {userInfo?.lastname}
                    </span>
                  </Typography.Link>
                </Menu.Item>
              </Menu>
            </Col>
          </Row>
        </ConfigProvider>
      </Layout>
      {ModalCartOpen && (
        <ModalCart
          show={ModalCartOpen}
          close={() => setModalCartOpen(false)}
          cuscode={userInfo.userid}
        ></ModalCart>
      )}
      <Modal
        title="ออกจากระบบ"
        open={ModalLogoutOpen}
        onOk={onLogout}
        onCancel={() => setModalLogoutOpen(false)}
        okText="ยืนยัน"
        cancelText="ยกเลิก"
        okButtonProps={{
          style: { backgroundColor: "#fa3f3f", color: "#FFFFFF" },
        }}
        cancelButtonProps={{
          style: { backgroundColor: "#212F3D", color: "#FFF" },
        }}
      >
        <Alert
          message="คุณแน่ใจหรือไม่ ว่าต้องการออกจากระบบ"
          type="warning"
          showIcon
        />
      </Modal>
      <Modal
        title="เปลี่ยนรหัสผ่าน"
        open={ModalPasswordOpen}
        onOk={onChangePassword}
        onCancel={() => {
          passwordForm.resetFields();
          setModalPasswordOpen(false);
        }}
        okText="บันทึก"
        cancelText="ยกเลิก"
        confirmLoading={passwordSaving}
        okButtonProps={{
          style: { backgroundColor: "#2dce89", color: "#FFFFFF" },
        }}
        cancelButtonProps={{
          style: { backgroundColor: "#212F3D", color: "#FFF" },
        }}
      >
        <Form form={passwordForm} layout="vertical" autoComplete="off">
          <Form.Item
            label="รหัสผ่านเดิม"
            name="oldpwd"
            rules={[{ required: true, message: "กรุณากรอกรหัสผ่านเดิม" }]}
          >
            <Input.Password placeholder="กรอกรหัสผ่านเดิม" />
          </Form.Item>
          <Form.Item
            label="รหัสผ่านใหม่"
            name="newpwd"
            rules={[
              { required: true, message: "กรุณากรอกรหัสผ่านใหม่" },
              { min: 6, message: "รหัสผ่านต้องยาวอย่างน้อย 6 ตัวอักษร" },
            ]}
          >
            <Input.Password placeholder="กรอกรหัสผ่านใหม่" />
          </Form.Item>
          <Form.Item
            label="ยืนยันรหัสผ่านใหม่"
            name="confirmpwd"
            dependencies={["newpwd"]}
            rules={[
              { required: true, message: "กรุณายืนยันรหัสผ่านใหม่" },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("newpwd") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    new Error("รหัสผ่านใหม่ไม่ตรงกัน")
                  );
                },
              }),
            ]}
          >
            <Input.Password placeholder="กรอกรหัสผ่านใหม่อีกครั้ง" />
          </Form.Item>
        </Form>
      </Modal>
    </Spin>
  );
};
export default App;
